<div class="login-page">
  <div class="card card-outline mx-auto" style="width: 95%; max-width: 600px;">
    <div class="login-logo text-center mt-2">
      <a class="welcome-text">Welcome to <strong>MyRoots</strong> Portal</a>
      <div class="mt-3">
        <img src="assets/dmk.png" alt="Logo" class="logo-img">
      </div>
    </div>
    <div class="card-body login-card-body">

      <div class="mb-4">
        <h5 style="font-size: 1rem;"><b>Password Requirements:</b></h5>
        <p style="font-size: 0.8rem;">Your password must be at least 8 characters long and include a lowercase letter,
          an uppercase letter, a number, and a special character.<span style="color: red;font-weight: bold;">*</span>
        </p>
      </div>
      <!-- Form -->
      <form [formGroup]="resetpassword" (ngSubmit)="postdata(resetpassword)">

        <div class="form-group">
          <label class="label">New Password<span style="color: red;font-weight: bold;"> *</span></label>
          <div class="input-group">
            <input type="password" name="password" formControlName="password" class="form-control"
              [type]="passwordFieldType" required>
            <div class="input-group-append">
              <span class="input-group-text" (click)="togglePasswordVisibility()">
                <i [class]="passwordFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
              </span>
            </div>
          </div>
          <div *ngIf="resetpassword.get('password').touched">
            <div *ngIf="resetpassword.get('password').hasError('required')" style="color: red;">
              This field is required.
            </div>
            <div *ngIf="resetpassword.get('password').hasError('passwordStrength')"
              style="color: red; font-size: 0.8rem;">
              Password must be at least 8 characters long with a mix of uppercase, lowercase, numbers, and special
              characters.
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Confirm Password<span style="color: red;font-weight: bold;"> *</span></label>
          <div class="input-group">
            <input type="password" formControlName="cpassword" name="cpassword" class="form-control"
              [type]="confirmPasswordFieldType" required>
            <div class="input-group-append">
              <span class="input-group-text" (click)="toggleConfirmPasswordVisibility()">
                <i [class]="confirmPasswordFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button class="btn btn-primary mt-3 submit">Submit</button>
        </div>
      </form>

    </div>
  </div>
</div>